
import { mapState, mapMutations, mapActions } from 'vuex'
import {v4 as uuidv4} from 'uuid'
import { defineComponent } from '@vue/runtime-core'
import Session from '@/interface/timer/session.interface'
import { Solve } from '@/interface/timer/solve.interface'

let puzzleMap = new Map<string, string>(
  [
    ['3x3x3', "3x3x3"],
    ['2x2x2', "2x2x2"],
    ['4x4x4', "4x4x4"],
    ['5x5x5', "5x5x5"],
    ['6x6x6', "6x6x6"],
    ['7x7x7', "7x7x7"],
    ['3x3x3 Blindfolded (3BLD)', "3x3x3"],
    ['3x3x3 Fewest Moves (FMC)', "3x3x3"],
    ['3x3x3 One-Handed', "3x3x3"],
    ['Megaminx', "megaminx"],
    ['Pyraminx', "pyraminx"],
    ['Clock', "clock"],
    ['Skewb', "skewb"],
    ['Square-1', "square1"],
    ['4x4x4 Blindfolded (4BLD)', "4x4x4"],
    ['5x5x5 Blindfolded (5BLD)', "5x5x5"],
    ['3x3x3 Multi-Blind (MBLD)', "3x3x3"],
  ]
);
export default defineComponent({
  name: "CreateSessionModal",
  data() {
    return {
      selectedPuzzle: '3x3x3',
      puzzleList: [
          '3x3x3',
          '2x2x2',
          '4x4x4',
          '5x5x5',
          '6x6x6',
          '7x7x7',
          '3x3x3 Blindfolded (3BLD)',
          '3x3x3 Fewest Moves (FMC)',
          '3x3x3 One-Handed',
          'Megaminx',
          'Pyraminx',
          'Clock',
          'Skewb',
          'Square-1',
          '4x4x4 Blindfolded (4BLD)',
          '5x5x5 Blindfolded (5BLD)',
          '3x3x3 Multi-Blind (MBLD)',
      ]
    }
  },
  methods: {
    createNewSession(){
      var newSession = {
        _id: uuidv4(),
        name: `${this.selectedPuzzle}_${this.allSessions.length+1}`,
        puzzle: puzzleMap.get(this.selectedPuzzle),
        solveList: [] as Array<Solve>
      } as Session

      this.addNewSession(newSession)
      window.location.reload();

    },
    toggleModal(): void{
      this.ToggleModal();
    },
    ...mapMutations('modalModule', ['ToggleModal']),
    ...mapMutations('sessionsModule', ['SetCurrentSession']),
    ...mapActions('sessionsModule', ['addNewSession'])
  },
  computed: {
    ...mapState('modalModule', ['modalState']),
    ...mapState('sessionsModule', ['allSessions']),
  }
})
